import React, { useMemo } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, CardImg, Col, Container, Label, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import { orders } from "../../common/data";
import { Link } from "react-router-dom";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import { useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const TeacherReport = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    // Function to export table as Excel file
    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(orders);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Teachers Report");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(data, "Teachers_Report.xlsx");
    };

    // Function to export table as PDF file
    const exportToPDF = () => {
        const doc = new jsPDF();
        doc.text("Teachers Report", 14, 10);
        doc.autoTable({
            head: [["ID", "Employee ID", "Join Date", "Full Name", "Class & Div"]],
            body: orders.map((row) => [row.id, row.orderid, row.orderdate, row.billingname, row.total]),
        });
        doc.save("Teachers_Report.pdf");
    };

    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Photo",
                accessor: () => (
                    <CardImg src={avatar4} alt="Brandstrek" className="rounded avatar-md" />
                ),
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Employee ID",
                accessor: "orderid",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Join Date",
                accessor: "orderdate",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Full Name",
                accessor: "billingname",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Class & Div",
                accessor: "total",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Action",
                accessor: () => (
                    <>
                        <Link to="/admin/students/view?student=X100001" className="me-3 text-primary"><i className="mdi mdi-eye font-size-18"></i></Link>
                        <Link to="#" className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                        <Link to="#" className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                    </>
                ),
                disableFilters: true,
                filterable: false,
            },
        ],
        []
    );

    const breadcrumbItems = [
        { title: "Teachers", link: "/" },
        { title: "Reports", link: "#" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Teachers" breadcrumbItems={breadcrumbItems} />
                    <Card>
                        <CardBody>
                            <Row className="mb-3">
                                <Col lg={2}>
                                    <div className="mb-3">
                                        <Label className="form-label">Class</Label>
                                        <select className="form-control select2">
                                            <option>Select</option>
                                            <option value="EL">Class 1</option>
                                            <option value="FA">Class 2</option>
                                            <option value="FI">Class 3</option>
                                        </select>
                                        <i className="mdi mdi-chevron-down " style={{ position: 'absolute', right: '20px', top: 'calc(50% - 5px)', pointerEvents: 'none' }}></i>
                                    </div>
                                </Col>
                                <Col lg={2}>
                                    <div className="mb-3">
                                        <Label className="form-label">Division</Label>
                                        <select className="form-control select2">
                                            <option>Select</option>
                                            <option value="EL">Div 1</option>
                                            <option value="FA">Div 2</option>
                                            <option value="FI">Div 3</option>
                                        </select>
                                        <i className="mdi mdi-chevron-down " style={{ position: 'absolute', right: '20px', top: 'calc(50% - 5px)', pointerEvents: 'none' }}></i>
                                    </div>
                                </Col>
                                <Col lg={2}>
                                    <div className="mb-3">
                                        <Label className="form-label">House</Label>
                                        <select className="form-control select2">
                                            <option>Select</option>
                                            <option value="EL">Red</option>
                                            <option value="FA">Blue</option>
                                            <option value="FI">Yellow</option>
                                        </select>
                                        <i className="mdi mdi-chevron-down " style={{ position: 'absolute', right: '20px', top: 'calc(50% - 5px)', pointerEvents: 'none' }}></i>
                                    </div>
                                </Col>
                                <Col className="text-end">
                                    <Button color="secondary" onClick={window.print} className="me-2">
                                        <i className="mdi mdi-printer"></i> Print
                                    </Button>
                                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="d-inline-block">
                                        <DropdownToggle caret color="primary">
                                            <i className="mdi mdi-export"></i> Export
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem onClick={exportToPDF}>Export as PDF</DropdownItem>
                                            <DropdownItem onClick={exportToExcel}>Export as Excel</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </Row>

                            <TableContainer
                                columns={columns || []}
                                data={orders || []}
                                isPagination={false}
                                iscustomPageSize={false}
                                isBordered={false}
                                customPageSize={10}
                                className="custom-header-css table align-middle table-nowrap"
                                tableClassName="table-centered align-middle table-nowrap mb-0"
                                theadClassName="text-muted table-light"
                            />
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default TeacherReport;
